!function (e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("react-bootstrap"), require("react-bootstrap-tools"));else if ("function" === typeof define && define.amd) define(["react", "react-bootstrap", "react-bootstrap-tools"], t);else {
    var r = "object" === typeof exports ? t(require("react"), require("react-bootstrap"), require("react-bootstrap-tools")) : t(e.react, e["react-bootstrap"], e["react-bootstrap-tools"]);

    for (var n in r) {
      ("object" === typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e, t, r) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/", r(r.s = 1);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    e.exports = r(2);
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(r(3)),
        a = n(r(5));
    t.Filter = a.default;
    var s = n(r(8));
    t.Sorter = s.default, t.default = o.default;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e = function e(t, r) {
        return (_e = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        o = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = o(r(0)),
        s = r(0),
        u = r(4),
        l = function (e) {
      function t(t) {
        var r = e.call(this, t) || this;
        r.changeFilter = function (e) {
          r.setState({
            filterValue: e,
            content: u.transformContent(r.props.content, e, r.props.filters, r.state.sorters, r.props.allwaysTopRule)
          });
        }, r.changeSorter = function (e, t) {
          var n = u.getChangedSorters(r.state.sorters, e, t);
          r.setState({
            sorters: n,
            content: u.transformContent(r.props.content, r.state.filterValue, r.props.filters, n, r.props.allwaysTopRule)
          });
        }, r.getChildAdditionalProps = function (e) {
          switch (e) {
            case "filterSorter":
              return {
                filterValue: r.state.filterValue,
                sorters: r.state.sorters,
                originalItemsNumber: r.props.content.length,
                transformedItemsNumber: r.state.content.length,
                handleFilterChange: r.changeFilter,
                handleSorterClick: r.changeSorter
              };

            case "content":
              return {
                content: r.state.content
              };

            default:
              return null;
          }
        };
        var n = t.filterValue,
            o = t.sorters;
        return r.state = {
          filterValue: n,
          sorters: o,
          content: u.transformContent(t.content, n, t.filters, o, t.allwaysTopRule)
        }, r;
      }

      return n(t, e), t.prototype.componentWillReceiveProps = function (e) {
        this.setState({
          content: u.transformContent(e.content, this.state.filterValue, this.props.filters, this.state.sorters, this.props.allwaysTopRule)
        });
      }, t.prototype.render = function () {
        var e = this;
        return a.cloneElement(this.props.component ? this.props.component : a.createElement("div", null), {
          className: "FilterSorter",
          children: a.Children.map(this.props.children, function (t) {
            return a.cloneElement(t, e.getChildAdditionalProps(t.props.componentRole));
          })
        });
      }, t;
    }(s.PureComponent);

    t.FilterSorterComponent = l, t.default = l;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.transformContent = function (e, t, r, o, a) {
      var s,
          u,
          l = t.toLowerCase(),
          i = e.filter(function (e) {
        if (0 === l.length) return !0;
        var t = !1;
        return r.forEach(function (r) {
          !t && (e[r] || "").toLowerCase().indexOf(l) > -1 && (t = !0);
        }), t;
      }),
          c = [];
      return a && (c = i.filter(function (e) {
        return e[a.key] === a.value;
      }), i = i.filter(function (e) {
        return e[a.key] !== a.value;
      })), o.forEach(function (e) {
        e.hasOwnProperty("selected") && (s = e.field, u = e.selected);
      }), n(c, s, u).concat(n(i, s, u));
    }, t.getChangedSorters = function (e, t, r) {
      return e.map(function (e) {
        var n = e.field,
            o = {
          field: n,
          label: e.label
        };
        return t === n && (o.selected = r), o;
      });
    };

    var n = function n(e, t, r) {
      return e.sort(function (e, n) {
        return e[t] < n[t] ? "asc" === r ? -1 : 1 : "asc" === r ? 1 : -1;
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__assign || function () {
      return (n = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) {
          for (var o in t = arguments[r]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = o(r(0)),
        s = r(6),
        u = r(7);
    t.Filter = function (e) {
      return a.default.createElement(u.InputGroup, n({}, s.getInputGroupProps(e)), a.default.createElement(u.Form.Control, n({}, s.getFormProps(e), {
        onChange: function onChange(t) {
          return e.onChange(t.target.value);
        },
        onKeyDown: function onKeyDown(t) {
          "Escape" === t.key && e.onChange("");
        }
      })), a.default.createElement(u.InputGroup.Append, null, a.default.createElement(u.InputGroup.Text, null, e.transformedItemsNumber, "/", e.originalItemsNumber)));
    }, t.default = t.Filter;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getInputGroupProps = function (e) {
      var t = {};
      return e.className && (t.className = e.className), t;
    }, t.getFormProps = function (e) {
      var t = {
        type: "text",
        maxLength: e.maxLength ? e.maxLength : "20",
        value: e.value ? e.value : "",
        placeholder: e.placeholder ? e.placeholder : null
      };
      return e.formClassName && (t.formClassName = e.formClassName), t;
    };
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__assign || function () {
      return (n = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) {
          for (var o in t = arguments[r]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = o(r(0)),
        s = r(9),
        u = r(10);
    t.Sorter = function (e) {
      var t = function t(_t) {
        e.onClick(e.sorter.field, _t);
      };

      return a.default.createElement("div", n({}, u.getSorterProps(e)), e.sorter.label, ["asc", "desc"].map(function (r) {
        return a.default.createElement(s.DescribedButton, n({}, u.getDirectionButtonProps(e, r), {
          onClick: t,
          onClickArg: r
        }));
      }));
    }, t.default = t.Sorter;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function n(e, t) {
      return "asc" === e ? e === t ? "arrow_drop_up" : "keyboard_arrow_up" : e === t ? "arrow_drop_down" : "keyboard_arrow_down";
    };

    t.getSorterProps = function (e) {
      var t = e.className ? e.className : "FilterSorterSorter" + (e.sorter.hasOwnProperty("selected") ? "--selected" : "");
      return e.additionalClassName && (t += " " + e.additionalClassName), {
        className: t
      };
    }, t.getDirectionButtonProps = function (e, t) {
      return {
        key: t,
        buttonClassName: o(e.directionClassName, e.sorter, t),
        icon: n(t, e.sorter.selected)
      };
    };

    var o = function o(e, t, r) {
      return e || "FilterSorterSorter__button" + (t.hasOwnProperty("selected") && t.selected === r ? "--selected" : "");
    };
  }]);
});